"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
function SolutionsConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 max-w-[90%] mx-auto">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="aspect-square animate-pulse rounded-lg bg-muted/50" />)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Failed to load product range.</p>
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>No products found in this category.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 max-w-[90%] mx-auto">
      {products.map((product, i) => {
      const imageUrl = product.featured_image_url || product.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/placeholder.png";
      const solutionLink = `${product.link}`;
      return <Link key={product.id} to={solutionLink} data-index={i} className="group block h-full">
            <Card className="p-6 rounded-lg overflow-hidden bg-white border border-border transition-all duration-300 flex flex-col items-center justify-between">
              <div className="aspect-square w-full overflow-hidden bg-white rounded-lg">
                <img src={imageUrl} alt={product.title} className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-110" loading="lazy" />
              </div>
              
              <div className="p-4 flex flex-col items-center text-center gap-[3px] w-full">
                <h3 className="font-default text-base font-bold leading-tight line-clamp-2 text-black">
                  {product.title}
                </h3>
                <Link to="/ContactPage" className="mt-2 w-full">
                  <Button className="w-full bg-primary text-white hover:bg-primary/90 rounded-lg">
                    Contact Us
                  </Button>
                </Link>
              </div>
            </Card>
          </Link>;
    })}
    </div>;
}
export default function SolutionsGrid() {
  const wp_query_params = {
    post_type: "product",
    per_page: 8
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="252306" id="premier-product-range" className="bg-white py-16 md:py-24 text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <div className="flex flex-col gap-4">
            <div className="inline-flex items-center rounded-lg border border-transparent px-3 py-1 font-bold tracking-widest uppercase text-black shadow-sm !text-left !text-4xl !font-sans">
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Best-selling Products
            </div>
          </div>
          <Link className="inline-flex items-center justify-center rounded-lg bg-primary/80 px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition-all hover:bg-primary hover:shadow-md" to="/ProductsPage">
            Learn more
          </Link>
        </div>
        
        <EcommerceProductsProvider wp_query={{
        post_type: "product",
        per_page: 8
      }}>
          <SolutionsConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}